import React from "react";
import img from "./BannerSmall.png";
import Button from "@material-ui/core/Button";
import "./BannerSmall1.css";

export default function BanerSmall1() {
  return (
    <div className="bannerSlider12">
      <div className="left1Small">
        <img src={img} alt="img" className="imgsmall21" />
        <div className="round">
          <h2 className="textRound">Seguridad</h2>
        </div>
      </div>
      <div className="right1">
        <div className="txtcont1">
          <h1 className="title1">
            COMO NOS <br /> MOVEMOS
          </h1>
          <h2 className="text23">
            Todos nuestros conductores pasan por un proceso de verificación y se
            encuentran en constante monitoreo para brindarte la mejor
            experiencia posible.
          </h2>
          <Button
            disableRipple
            variant="contained"
            color="default"
            className="btn1"
          >
            <p className="btnTxt1">Conoce más</p>
          </Button>
        </div>
      </div>
    </div>
  );
}
